import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    setGenerateRevisionLabel(context, payload) {
        return axios
            .post('/sendings/generate-revision-labels', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wydrukowanie etykiety nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getRevisionLabelDetails(context, objectToFind) {
        const type = objectToFind.type
        const number = objectToFind.number

        return axios
            .get(`/sendings/revision-labels-order-details/${type}/${number}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wyszukiwanie nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setBillboardLabelsSettings({ commit }, data) {
        commit('SET_BILLBOARD_LABELS_SETTINGS', data)
    },
    clearBillboardLabelsSettings({ commit }) {
        commit('CLEAR_BILLBOARD_LABELS_SETTINGS')
    },
    setStandardLabelsSettings({ commit }, data) {
        commit('SET_STANDARD_LABELS_SETTINGS', data)
    },
    clearStandardLabelsSettings({ commit }) {
        commit('CLEAR_STANDARD_LABELS_SETTINGS')
    },
    setRevisoryLabelsSettings({ commit }, data) {
        commit('SET_REVISORY_LABELS_SETTINGS', data)
    },
    clearRevisoryLabelsSettings({ commit }) {
        commit('CLEAR_REVISORY_LABELS_SETTINGS')
    },
}
